module.exports = __webpack_public_path__ + "img/how-it-works-header-mobile.2cd63ec1.png";